/* eslint-disable camelcase */

/**
 * NOTE: This is an auto-generated file
 */

import ArrowLeftWithBase from './assets/customer/default/special/ArrowLeftWithBase.svg';
import AudioDescription from './assets/customer/default/special/AudioDescription.svg';
import BackToLive from './assets/customer/default/special/BackToLive.svg';
import Chapter from './assets/customer/default/special/Chapter.svg';
import Cross from './assets/customer/default/special/Cross.svg';
import Info from './assets/customer/default/special/Info.svg';
import InfoFocused from './assets/customer/default/special/InfoFocused.svg';
import Live from './assets/customer/default/special/Live.svg';
import LiveFocused from './assets/customer/default/special/LiveFocused.svg';
import MultiDevices from './assets/customer/default/special/MultiDevices.svg';
import RelatedVideos from './assets/customer/default/special/RelatedVideos.svg';
import Remote from './assets/customer/default/special/Remote.svg';
import SkipNext from './assets/customer/default/special/SkipNext.svg';
import SkipNextFocused from './assets/customer/default/special/SkipNextFocused.svg';
import SkipPrevious from './assets/customer/default/special/SkipPrevious.svg';
import SkipPreviousFocused from './assets/customer/default/special/SkipPreviousFocused.svg';
import Speed from './assets/customer/default/special/Speed.svg';
import SpeedFilled from './assets/customer/default/special/SpeedFilled.svg';
import StartOver from './assets/customer/default/special/StartOver.svg';
import Timer from './assets/customer/default/special/Timer.svg';
import TimerFilled from './assets/customer/default/special/TimerFilled.svg';
import Tracks from './assets/customer/default/special/Tracks.svg';
import Usabilla from './assets/customer/default/special/Usabilla.svg';
import VOST from './assets/customer/default/special/VOST.svg';

export default {
  ArrowLeftWithBase,
  AudioDescription,
  BackToLive,
  Chapter,
  Cross,
  Info,
  InfoFocused,
  Live,
  LiveFocused,
  MultiDevices,
  RelatedVideos,
  Remote,
  SkipNext,
  SkipNextFocused,
  SkipPrevious,
  SkipPreviousFocused,
  Speed,
  SpeedFilled,
  StartOver,
  Timer,
  TimerFilled,
  Tracks,
  Usabilla,
  VOST,
};
